import React from 'react';
import { CTAButton } from '../CTAButton';
const sources = ['Textbooks', 'Lectures', 'Courses', 'Papers', 'Protocols', 'Years of education'];
export function About() {
  return <section className="bg-navy-900 py-14 sm:py-20" data-id="element-58" data-mp="12qx1n9b9qeal">
      <div className="mx-auto w-full max-w-4xl px-4" data-id="element-59" data-mp="12qdfthihz5ra">
        <div className="grid items-start gap-8 md:grid-cols-[minmax(0,300px)_minmax(0,1fr)]" data-id="element-60" data-mp="ypl84sp9x8x4">
          <div data-id="element-61" data-mp="azhdhau2cji9">
            <img src="https://cdn.magicpatterns.com/uploads/iv19MW7qU4M4BSMXuTGXww/Dra._Karito_Odontologa_OF.png" alt="Dr. Karito, orthodontist and creator of Mechanics Decision Map™" className="mx-auto w-full max-w-[280px] rounded-2xl object-cover ring-1 ring-white/15 md:max-w-none" width={943} height={1500} loading="lazy" data-id="element-62" data-mp="ayxwpxg5g15t" />
          </div>

          <div data-id="element-63" data-mp="3nfbadfv20g90">
            <span className="inline-block rounded-full bg-white/10 px-3.5 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.12em] text-sky-400 sm:text-xs" data-id="element-64" data-mp="3neroxp6739q8">
              🦷 About Dr. Karito
            </span>
            <h2 className="mt-4 font-display text-[26px] font-bold leading-tight text-white sm:text-3xl" data-id="element-65" data-mp="388bhrj4bdp67">
              From biomechanical theory to a system for structuring clinical reasoning
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-white/75" data-id="element-66" data-mp="3hxv1ss3rjp2n">
              Over the years, Dr. Karito recognized a common challenge when dealing with complex orthodontic
              mechanics: the problem isn’t always a lack of information.
            </p>

            <ul className="mt-5 flex flex-wrap gap-2" data-id="element-67" data-mp="2pbacdx6uln1q">
              {sources.map(source => <li key={source} className="rounded-lg bg-white/[0.07] px-3 py-1.5 text-[12.5px] font-semibold text-white/80 ring-1 ring-white/10" data-id="element-68" data-mp="2uawpm6mof3aj">
                  {source}
                </li>)}
            </ul>

            <p className="mt-5 text-[15px] leading-relaxed text-white/75" data-id="element-69" data-mp="efl3fo993ait">
              Yet when a complex case appears, one question can still remain:
            </p>
            <p className="mt-3 border-l-2 border-sky-500 pl-4 font-display text-xl font-bold italic leading-snug text-white sm:text-2xl" data-id="element-70" data-mp="25kejupubxa91">
              “Where do I start?”
            </p>
            <p className="mt-5 text-[15px] leading-relaxed text-white/75" data-id="element-71" data-mp="2fjdtaamx59x3">
              That question inspired Mechanics Decision Map™. Not another theoretical course. Not another
              collection of PDFs to read from beginning to end. But a visual system of decision maps,
              protocols, checklists, and planning tools designed to help organize biomechanical reasoning
              before activating a mechanic.
            </p>

            <div className="mt-6 rounded-2xl bg-white/[0.06] p-5 ring-1 ring-white/10" data-id="element-72" data-mp="1vtjv9etm1ykf">
              <p className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-sky-400" data-id="element-73" data-mp="184948p22bijh">
                The philosophy
              </p>
              <ol className="mt-3 space-y-2 text-[15px] leading-relaxed text-white/85" data-id="element-74" data-mp="u009l18liz1v">
                <li data-id="element-75" data-mp="yr08ud56tt7j">1. Define the objective first.</li>
                <li data-id="element-76" data-mp="ysl27zfrn63t">2. Then analyze the force system.</li>
                <li data-id="element-77" data-mp="k35deozspaqr">3. Then decide how to act and what to control.</li>
              </ol>
            </div>
          </div>
        </div>

        <div className="mx-auto mt-9 max-w-xl" data-id="element-78" data-mp="p1yq4f79cxpv">
          <CTAButton label="Yes — I want Mechanics Decision Map™" data-id="element-79" data-mp="1crb19km5bfut" />
        </div>
      </div>
    </section>;
}